// Never filtered: keys that edit or move (Enter reaches the form) and Ctrl/Cmd shortcuts, except paste.
// AltGr (Ctrl+Alt) and Option type characters, so those are still filtered.
const isControlKey = (e: any) =>
    typeof e?.key !== 'string' || e.key.length !== 1 ||
    ((e.ctrlKey || e.metaKey) && !e.altKey && !e.getModifierState?.('AltGraph') && e.key.toLowerCase() !== 'v');

export const validateEmail = (e: any) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(e.target.value)) {
        e.preventDefault();
    }
};
export const validateNoSpecialCharsOrSpaces = (e: any) => {
    if (isControlKey(e)) return;
    const invalidPattern = /[^\w]/;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
    if (invalidPattern.test(e.key && !allowedKeys.includes(e.key))) {
        e.preventDefault();
    }
};
export const validateNoSpecialChars = (e: any) => {
    if (isControlKey(e)) return;
    const invalidSpecialCharsPattern = /[^a-zA-Z0-9\s]/;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
    if (invalidSpecialCharsPattern.test(e.key && !allowedKeys.includes(e.key))) {
        e.preventDefault();
    }
};
export const validateOnlyNumbers = (e: any) => {
    if (isControlKey(e)) return;
    const validPattern = /^[0-9]$/;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

    if (!validPattern.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
        return;
    }

    if (e.target.value.length >= 3 && validPattern.test(e.key)) {
        e.preventDefault();
    }
};

export const validateOnlyNumbersNotThree = (e: any) => {
    if (isControlKey(e)) return;
    const validPattern = /^[0-9]$/;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

    if (!validPattern.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
        return;
    }
};

export const validatePhoneNumber = (e: any) => {
    if (isControlKey(e)) return;
    const validPattern = /^[0-9+]$/;
    const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Enter",
    ];

    if (!validPattern.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
    }
    if (e.key === '+' && e.target.value.includes('+')) {
        e.preventDefault();
    }
};

export const validateDecimalNumer = (e: any) => {
    if (isControlKey(e)) return;
    const validPattern = /^[0-9]$/;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "."];
    const inputValue = e.target.value;

    const hasDecimalPoint = inputValue.includes(".");
    if (e.key === "." && hasDecimalPoint) {
        e.preventDefault();
        return;
    }
    if (!validPattern.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
    }
}
/**
 * Reverse of what URLSearchParams.toString() writes: percent-decode and turn
 * '+' back into a space. Without this a search for "Coca Cola" comes back out
 * of the URL as the literal "Coca+Cola" / "Coca%20Cola" and matches nothing.
 * A malformed sequence (a bare '%' the user typed) is returned as-is rather
 * than throwing URIError and blanking the whole filter.
 */
const decodeParamValue = (raw: string): string => {
    if (raw === undefined || raw === null) return '';
    try {
        return decodeURIComponent(String(raw).replace(/\+/g, ' '));
    } catch {
        return String(raw);
    }
};

export const extractValues = (arr: any) => {
    const result: any = {};
    arr.forEach((item: any) => {
        const pair = String(item ?? '').includes("?") ? String(item).split("?")[1] : String(item ?? '');
        const separator = pair.indexOf("=");
        if (separator < 0) return;
        // Split on the FIRST '=' only: a value may legitimately contain one.
        result[decodeParamValue(pair.slice(0, separator))] = decodeParamValue(pair.slice(separator + 1));
    });

    return result;
};
/**
 * Build the query string for a list screen. URLSearchParams percent-encodes
 * every value it is given, so the result always round-trips through
 * extractValues above. `extra` carries the per-screen keys (filters, sort)
 * that are not part of the shared search / tab / page / limit set.
 */
export const updateUrlParams = (params: any, extra?: Record<string, any>) => {
    const urlParams = new URLSearchParams();
    if (params.searchValue) urlParams.set('search', params.searchValue);
    if (params.tab) urlParams.set('tab', params.tab);
    if (params.page) urlParams.set('page', params.page.toString());
    if (params.limit) urlParams.set('limit', params.limit.toString());
    if (extra) {
        Object.keys(extra).forEach((key: string) => {
            const value = extra[key];
            if (value === undefined || value === null || value === '') return;
            urlParams.set(key, String(value));
        });
    }
    return `?${urlParams.toString()}`;
};